import { z } from 'zod';
import { DURATION_MINUTES_MAX } from '../limits.js';
import { ContactIdSchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
export const ActivityTypeSchema = z.enum([
    'call_outbound',
    'call_inbound',
    'email_sent_external',
    'email_received',
    'meeting_held',
    'note',
    'document_shared',
    'stage_changed',
    'quote_created',
    'submission_sent',
    'submission_discarded',
    // RIG-500 — the proposal was replaced by a revised one. Distinct from
    // `submission_discarded` so the feed says "revised", not "discarded", for
    // work that is still live under a new proposal.
    'submission_superseded',
    'task_completed',
    'system_event',
]);
export const ActivityOutcomeSchema = z.enum([
    'discovery_done',
    'demo_done',
    'objection_raised',
    'next_step_set',
    'no_response',
    'deal_advanced',
    'decision_committed',
    'disqualified',
]);
export const ActivitySentimentSchema = z.enum(['positive', 'neutral', 'negative']);
export const ActivitySchema = z.object({
    id: IDSchema,
    type: z.literal('activity'),
    schemaVersion: SchemaVersionSchema,
    accountId: IDSchema,
    activityType: ActivityTypeSchema,
    occurredAt: IsoTimestampSchema,
    loggedBy: z.string(),
    dealId: IDSchema.optional(),
    submissionId: IDSchema.optional(),
    meetingId: IDSchema.optional(),
    taskId: IDSchema.optional(),
    contactId: ContactIdSchema.optional(),
    outcome: ActivityOutcomeSchema.optional(),
    briefNote: z.string().optional(),
    // QA 2026-10-01 F-08 — same ceiling as the activity routes.
    durationMinutes: z.number().int().nonnegative().max(DURATION_MINUTES_MAX).optional(),
    sentiment: ActivitySentimentSchema.optional(),
    tags: z.array(z.string()).default([]),
    autoLogged: z.boolean().default(false),
    autoLogSource: z.enum(['outlook_email', 'calendar_event', 'system_event']).optional(),
    autoLogReference: z.string().optional(),
    // T9-011 — Outlook message id for dedup of auto-logged email activity rows.
    outlookMessageId: z.string().optional(),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    /** QA 2026-10-01 F-42: deleted together with its account (restore brings it back). */
    deletedByCascade: z.boolean().default(false),
    version: z.number().int().positive(),
});
//# sourceMappingURL=activity.js.map